/*function getThumbnail(path, thumbPath, thumbSize) {
  // NOTE: be sure --asar.unpack=*.exe is set to make ffmpeg.exe unpacked.
  // Otherwise, it will not run in the production build
  const ffmpegPath = window.require('ffmpeg-static').path.replace('app.asar', 'app.asar.unpacked')
  console.log('getThumbnail:', ffmpegPath)

  if (thumbSize === undefined)
    thumbSize = 150

  const genThumbnail = window.require('simple-thumbnail')
  return genThumbnail(path, thumbPath, thumbSize + 'x?', { path: ffmpegPath })
}*/
//TODO: https://jsfiddle.net/codeandcloud/xor3L8db/
function getThumb(image, width, height, callback) {
  let canvas = document.createElement('canvas')
  let ctx = canvas.getContext('2d')
  // set its dimension to target size  
  canvas.width = width
  canvas.height = height
  // draw source image into the off-screen canvas:
  ctx.drawImage(image, 0, 0, width, height)
  let data = canvas.toDataURL('image/jpeg', 0.8)
  let result = data.split(';base64,').pop()
  callback(result)
}

const imageUtils = { 
  getImageThumbnail: function(path, thumbnailPath, thumbSize) {
    return ''//getThumbnail(path, thumbnailPath, thumbSize)
  },

  getVideoThumbnail: function(path, thumbnailPath, thumbSize) {
    return ''//getThumbnail(path, thumbnailPath, thumbSize)
  },

  resizeImage: function(base64Data, width, height) {
    return new Promise(resolve => {
      let img = new Image
      img.onload = function() {
        getThumb(this, width, height, (data) => {
          resolve(data)
        })
      }
      img.src = 'data:image/*;base64,' + base64Data
    })
  }
}

export default imageUtils